const scrollTo = (element, offset = { top: 0, left: 0 }) => {
	const rect = element.getBoundingClientRect();
	window.scrollTo(rect.left + offset.left, rect.top + offset.top);
};

/**
 * Smooth scrolling links.
 *
 * @see https://github.com/shoelace-style/shoelace/blob/next/docs/assets/scripts/docs.js
 * @description Smooth scrolling for the documentation site.
 * @author Shoelace
 */
const smoothlinks = () => {
	document.addEventListener('click', event => {
		const link = event.target.closest('a');
		const id = (link?.hash ?? '').substr(1);
		const isFragment = link?.hasAttribute('href') && link?.getAttribute('href').startsWith('#');

		if (!link || !isFragment || link.getAttribute('data-smooth-link') === 'false') {
			return;
		}

		// Scroll to the top
		if (link.hash === '') {
			event.preventDefault();
			window.scroll({ top: 0, behavior: 'smooth' });
			history.pushState(undefined, undefined, location.pathname);
		}

		// Scroll to an id
		if (id) {
			const target = document.getElementById(id);

			if (target) {
				event.preventDefault();
				window.scroll({ top: target.offsetTop, behavior: 'smooth' });
				history.pushState(undefined, undefined, `#${id}`);
			}
		}
	});
}

export { scrollTo,smoothlinks };
